export function Transformation() {
  const transformations = [
    {
      icon: 'ri-shield-star-line',
      title: 'An Authority Asset',
      description: 'Position yourself as the definitive expert in your field with a professionally published book that validates your expertise.'
    },
    {
      icon: 'ri-user-add-line',
      title: 'A Lead-Generation Tool',
      description: 'Attract high-quality clients and opportunities by using your book as a powerful marketing asset that works 24/7.'
    },
    {
      icon: 'ri-award-line',
      title: 'A Credibility Builder',
      description: 'Instantly elevate your professional standing and differentiate yourself from competitors who haven\'t published.'
    },
    {
      icon: 'ri-newspaper-line',
      title: 'A Media Story',
      description: 'Generate press coverage, podcast invitations, and media features that amplify your message and reach.'
    },
    {
      icon: 'ri-mic-line',
      title: 'A Speaking Platform',
      description: 'Open doors to keynote opportunities, conferences, and speaking engagements that expand your influence.'
    },
    {
      icon: 'ri-film-line',
      title: 'A Potential Film Adaptation',
      description: 'Position your story for screen adaptation opportunities with proper formatting and adaptation readiness review.'
    }
  ];

  return (
    <section className="bg-gradient-to-b from-black via-[#0A0A0A] to-black py-28">
      <div className="max-w-[1400px] mx-auto px-20">
        <div className="text-center mb-20">
          <div className="text-[#D4AF37] text-xs uppercase tracking-[0.2em] font-medium mb-4">
            The Transformation
          </div>
          <h2 className="text-white text-5xl font-bold mb-5">
            More Than Publishing
          </h2>
          <div className="w-20 h-1 bg-[#D4AF37] rounded-full mx-auto mb-6"></div>
          <p className="text-[#999999] text-lg max-w-3xl mx-auto leading-relaxed">
            Your book isn't just a product—it's a strategic asset that transforms your business, brand, and opportunities.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-8">
          {transformations.map((item, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-br from-[#1C1C1C] to-[#0F0F0F] rounded-2xl p-12 border border-[#D4AF37]/10 hover:border-[#D4AF37]/30 transition-all duration-500 overflow-hidden"
            >
              <div className="absolute top-0 right-0 w-40 h-40 bg-[#D4AF37]/5 rounded-full blur-3xl group-hover:bg-[#D4AF37]/10 transition-all duration-500"></div>
              
              <div className="relative z-10">
                <div className="flex items-start gap-6 mb-6">
                  <div className="w-20 h-20 flex items-center justify-center rounded-2xl bg-[#D4AF37]/10 group-hover:bg-[#D4AF37]/20 transition-all duration-300 flex-shrink-0">
                    <i className={`${item.icon} text-[#D4AF37] text-4xl`}></i>
                  </div>
                  <div>
                    <h3 className="text-white text-2xl font-bold mb-3 group-hover:text-[#D4AF37] transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-[#999999] text-base leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-block bg-gradient-to-r from-[#D4AF37]/10 via-[#D4AF37]/5 to-[#D4AF37]/10 rounded-2xl px-10 py-8 border border-[#D4AF37]/20">
            <p className="text-white text-lg font-medium mb-2">
              Ready to transform your manuscript into a multi-dimensional asset?
            </p>
            <p className="text-[#999999] text-base">
              Let's discuss how your book can create lasting impact and opportunities.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}